import {Component} from 'react';

class BackEndLogListCard extends Component {
  constructor(props) {
    super(props);
    this.state={
   
    }   
}
  
render() {
      let metricValue = this.props.logData.metricValue;
      if (!isNaN(this.props.logData.metricValue)){
          metricValue = (+this.props.logData.metricValue).toFixed(2);
      }
return <>
      <tr>
          <td className="text-center" >
               {this.props.logData.processName}
          </td>
          <td className="text-left" >
               {this.props.logData.metricName}
          </td>
          <td className="text-center" >
               {metricValue}
          </td>
          <td className="text-left" >
               {this.props.logData.comment}
          </td>
          <td className="text-center" >
               {this.props.logData.dateAdded}
          </td>
          <td className="text-center" >
               {this.props.logData.sequenceNbr}
          </td>
           <td className="text-center" >
               {this.props.logData.timeAdded}
          </td>
     </tr>         
           
   </>
  }
}

export default BackEndLogListCard;